import View from 'ln/view/View';
import VideoPlayer from '../VideoPlayer';

class MuteButton extends View{

    private resetVolume:number;

    constructor( public player:VideoPlayer ){
        super();

        this.defaultTemplate = 'lv.video-mute'

    }

    public init(){
        this.node.click.add( this.toggleVolume, this );
    }

    private toggleVolume(){

        if( this.player.video.volume == 0 ){
            this.player.video.volume = this.resetVolume;
        } else {
            this.resetVolume = this.player.video.volume;
            this.player.video.volume = 0;
        }

        this.node.js( 'mute' ).toggleClass( '-toggled' );
    }

}

export default MuteButton;